export const ChatPage = () => {
    return <div>This is chat page</div>;
};
